import { render } from "./PageTitleComponent.vue?vue&type=template&id=e0f9c4fc&ts=true"
import script from "./PageTitleComponent?vue&type=script&lang=ts"
export * from "./PageTitleComponent?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/xebel/xebel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__